import { ReactNode, useMemo } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'

export interface BasicModalInterface {
  children?: ReactNode
  isOpen?: boolean
  onClose(): void
}

export const BasicModal = ({ children, isOpen, onClose }: BasicModalInterface) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur`}
    >
      <div css={tw`bg-white rounded-lg max-w-[640px]`}>{children}</div>
    </Modal>
  )
}
